(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paradise-product"]) return;
  try {
    document.addEventListener('change',function(e){if(e.target.id==='pb-variant'){document.getElementById('pb-price').textContent=e.target.selectedOptions[0].dataset.price;}});
  } catch(e) { console.error(e); }
})();
})();
